import { Query } from "appwrite";
import { databases } from "./appwrite.js";

function databaseId() {
  const id = import.meta.env.VITE_APPWRITE_DB_ID?.trim();
  if (!id) throw new Error("Set VITE_APPWRITE_DB_ID in your environment.");
  return id;
}

function clientsCollectionId() {
  return import.meta.env.VITE_APPWRITE_COLLECTION_CLIENTS?.trim() || "clients";
}

function programsCollectionId() {
  return import.meta.env.VITE_APPWRITE_COLLECTION_PROGRAMS?.trim() || "programs";
}

export async function fetchCoachClientAndProgramTotals(coachId) {
  const db = databaseId();
  const coach = String(coachId ?? "").trim();
  if (!coach) throw new Error("Missing coach id.");

  const queries = [Query.equal("coachId", coach), Query.limit(1)];

  const [clientsRes, programsRes] = await Promise.all([
    databases.listDocuments({
      databaseId: db,
      collectionId: clientsCollectionId(),
      queries,
    }),
    databases.listDocuments({
      databaseId: db,
      collectionId: programsCollectionId(),
      queries,
    }),
  ]);

  return {
    clientTotal: Number(clientsRes.total) || 0,
    programTotal: Number(programsRes.total) || 0,
  };
}
